import {createTileLayerLegend} from "base/map";

export const portvesselsConfig = {
    urlTemplate:
        "https://ows.emodnet-humanactivities.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
    format: "image/png",
    opacity: 0.5,
    otherLayerOptions: {},
    layers: "portvessels",
    legend: createTileLayerLegend({
        layerName: "Vessels by Tonnage",
        layerType: "wms",
    }),
};

export const portvesselsbytypeConfig = {
    urlTemplate:
        "https://ows.emodnet-humanactivities.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
    format: "image/png",
    opacity: 0.5,
    otherLayerOptions: {},
    layers: "portvesselsbytype",
    legend: createTileLayerLegend({
        layerName: "Vessels by Type",
        layerType: "wms",
    }),
};

export const portgoodsConfig = {
    urlTemplate:
        "https://ows.emodnet-humanactivities.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
    format: "image/png",
    opacity: 0.5,
    otherLayerOptions: {},
    layers: "portgoods",
    legend: createTileLayerLegend({
        layerName: "Goods",
        layerType: "wms",
    }),
};

export const portpassengersConfig = {
    urlTemplate:
        "https://ows.emodnet-humanactivities.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
    format: "image/png",
    opacity: 0.5,
    otherLayerOptions: {},
    layers: "portpassengers",
    legend: createTileLayerLegend({
        layerName: "Passengers",
        layerType: "wms",
    }),
};
